module.exports = __webpack_public_path__ + "media/images/asc-782635b69394f6b0aa45981b06f874c0.png";